var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:({ transform: 'rotate('+ _vm.transform + 'deg)' }),attrs:{"viewBox":"0 0 16 16","width":_vm.size,"height":_vm.size}},[_c('path',{attrs:{"d":"M7.99 0L15.97 7.99L14.12 9.85L9.28 5V15.74H6.66V5.04L1.85 9.85L0 7.99L7.99 0Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }